import React, { useEffect, useState } from "react";
import Hoc from "../../../components/HOC";
import { useDispatch, useSelector } from "react-redux";
import {
  requestAddQuote,
  requestEditQuote,
  requestQuoteById,
  requestQuotesList,
  setResetAddQuoteState,
  setResetEditQuoteState,
  setResetQuotesListState,
  setResetStateQuoteById,
} from "../../../Redux/QuotesState/QuoteActionCreator";
import Loader from "../../../components/Loader";
import CustomDataTable from "../../../components/CustomDataTable";
import {
  MdEdit,
  MdCheck,
  MdClose,
  MdChevronLeft,
  MdChevronRight,
} from "react-icons/md";
import { toast } from "react-toastify";

const Quotes = () => {
  const dispatch = useDispatch();
  const quotesList = useSelector((state) => state.QuotesListReducer);
  const [isModalOpen, setIsModalOpen] = useState({ title: "", isOpen: false });
  const [quote, setQuote] = useState("");
  const addQuoteReducer = useSelector((state) => state.AddQuoteReducer);
  const editQuoteReducer = useSelector((state) => state.EditQuoteReducer);
  const quoteByIdReducer = useSelector((state) => state.QuoteByIdReducer);
  const [editingId, setEditingId] = useState(null);

  const initialValues = {
    quote: "",
  };

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
      grow: 1,
      cell: (row, index) => <span className="text-md font-medium">{index + 1}</span>,
    },
    {
      name: "Quote",
      selector: (row) => row.quote,
      sortable: true,
      grow: 3,
      cell: (row) => <span className="text-md font-medium">{row.quote}</span>,
    },
    {
      name: "Actions",
      grow: 1,
      cell: (row, index) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="text-primary hover:text-primaryDark"
          >
            <MdEdit size={24} />
          </button>
        </div>
      ),
    },
  ];

  const handleClick = () => {
    setIsModalOpen({ title: "Add Quote", isOpen: true });
  };

  const handleEdit = (row) => {
    dispatch(requestQuoteById(row.id));
    setIsModalOpen({ title: "Edit Quote", isOpen: true });
  };

  const handleSaveEdit = (id) => {
    if (!quote.trim()) {
      toast.error("Quote cannot be empty");
      return;
    }
    dispatch(requestEditQuote({ id, quote }));
    setEditingId(null);
    setQuote("");
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setQuote("");
  };

  const handleAddQuote = () => {
    if (!quote.trim()) {
      toast.error("Quote cannot be empty");
      return;
    }
    dispatch(requestAddQuote({ quote }));
    setIsModalOpen({ title: "", isOpen: false });
    setQuote("");
  };

  const handleEditQuote = () => {
    if (!quote.trim()) {
      toast.error("Quote cannot be empty");
      return;
    }
    dispatch(requestEditQuote({ id: quoteByIdReducer?.response?.id, quote }));
  };

  const handleQuoteClick = (selectedQuote) => {
    setQuote(selectedQuote.quote);
    dispatch(requestQuoteById(selectedQuote.id));
    setIsModalOpen({ title: "Edit Quote", isOpen: true });
  };

  const handlePageChange = (page) => {
    dispatch(
      requestQuotesList({
        page: page,
        size: quotesList?.size || 10,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(requestQuotesList({ page: 0, size: size }));
  };

  useEffect(() => {
    dispatch(setResetQuotesListState());
    dispatch(
      requestQuotesList({
        page: quotesList?.page,
        size: quotesList?.size 
      })
    );
    dispatch(setResetAddQuoteState());
  }, []);

  useEffect(() => {
    if (quotesList?.error && !quotesList?.loading) {
      toast.error("No Quotes found");
      dispatch(setResetQuotesListState());
    }
  }, [quotesList]);

  useEffect(() => {
    if (!addQuoteReducer?.loading && addQuoteReducer?.response) {
      toast.success("Quote is added");
      setIsModalOpen({ title: "", isOpen: false });
      setQuote("");
      dispatch(setResetAddQuoteState());
      dispatch(
        requestQuotesList({
          page: quotesList?.page || 0,
          size: quotesList?.size || 10,
        })
      );
    } else if (!addQuoteReducer?.loading && addQuoteReducer?.error) {
      toast.error("Error in adding Quote");
      dispatch(setResetAddQuoteState());
    }
  }, [addQuoteReducer]);

  useEffect(() => {
    if (!quoteByIdReducer?.loading && quoteByIdReducer?.response) {
      setQuote(quoteByIdReducer?.response?.quote);
    } else if (!quoteByIdReducer?.loading && quoteByIdReducer?.error) {
      toast.error("Error fetching Quote");
      dispatch(setResetStateQuoteById());
      setIsModalOpen({ title: "", isOpen: false });
    }
  }, [quoteByIdReducer]);

  useEffect(() => {
    if (!editQuoteReducer?.loading && editQuoteReducer?.response) {
      toast.success("Quote updated successfully");
      dispatch(
        requestQuotesList({
          page: quotesList?.page || 0,
          size: quotesList?.size || 10,
        })
      );
      setIsModalOpen({ title: "", isOpen: false });
      setQuote("");
      dispatch(setResetEditQuoteState());
      dispatch(setResetStateQuoteById());
    } else if (!editQuoteReducer?.loading && editQuoteReducer?.error) {
      toast.error("Error updating Quote");
      dispatch(setResetEditQuoteState());
    }
  }, [editQuoteReducer]);

  return (
    <div className="p-6 w-full h-[90vh]">
      <Loader isLoading={quotesList?.loading || quoteByIdReducer?.loading || editQuoteReducer?.loading} />
      <div className="absolute flex mb-4 z-10 right-6">
        <button
          onClick={handleClick}
          className="flex items-center justify-center bg-primary hover:bg-primaryDark text-white py-1 px-6 mr-4 rounded-full shadow-lg transition-all duration-300"
        >
          <span className="text-2xl font-medium">+</span>
        </button>
      </div>
      <div className="mt-4">
     <CustomDataTable
     columns={columns}
     data={quotesList?.response?.content}
     serverPagenation
     paginationTotalRows={quotesList?.response?.totalElements}
     handleChangePage={handlePageChange}
     handleRowsChange={handleRowsChange}
     fixedHeaderScrollHeight={"59vh"}
     />
     </div>

      {isModalOpen.isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-2xl shadow-xl">
            <h2 className="text-xl font-semibold mb-3 text-gray-800">
              {isModalOpen.title}
            </h2>

            <textarea
              value={quote}
              onChange={(e) => setQuote(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md mb-3 resize-none focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              rows={4}
              placeholder="Type your quote here..."
            ></textarea>

            <div className="flex justify-end mt-4 space-x-3">
              <button
                onClick={() => {
                  setIsModalOpen({ title: "", isOpen: false });
                  setQuote("");
                  dispatch(setResetStateQuoteById());
                }}
                className="px-4 py-2 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                onClick={
                  isModalOpen.title === "Edit Quote"
                    ? handleEditQuote
                    : handleAddQuote
                }
                className="px-4 py-2 rounded-md bg-primary hover:bg-primaryDark text-white transition-colors duration-200"
                disabled={editQuoteReducer?.loading || quoteByIdReducer?.loading}
              >
                {isModalOpen.title === "Edit Quote" 
                  ? (editQuoteReducer?.loading ? "Updating..." : "Update")
                  : (addQuoteReducer?.loading ? "Adding..." : "Add")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hoc(Quotes);
